var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.gestor_scrap_free_svg(_vm.siniestro_prop))?_c('img',{staticClass:"siniestro-svg-img",attrs:{"src":_vm.gestor_scrap_free_svg(_vm.siniestro_prop)}}):_vm._e(),_vm._v(" "+_vm._s(_vm.siniestro_prop.numero_siniestro)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }